import script from "./GrouperBodyFullscreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperBodyFullscreen.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperBodyFullscreen.vue?vue&type=style&index=0&id=42aeb8ff&lang=scss"

const __exports__ = script;

export default __exports__
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlideTransition,QSplitter,QTabPanel});
